import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import history from "../history";
import { Button } from "../common";
import * as style from "./RightToWork/styles.module.scss";

const YotiCheckSuccessful = ({
  nextStepLink,
  findStep,
  jobId,
  setRTWVerified,
}) => {
  const navigateForward = () => {
    history.push(nextStepLink);
    setRTWVerified(true);
  };
  return (
    <Fragment>
      <div>
        <div className="mb-1">
          <p className="mb-1 font-weight-bold">
            Your Right to work check is now complete.
          </p>
          <p>
            Your local branch will be in touch within the next 24 hours, however
            you can contact them sooner if you wish.
          </p>
          <p>
            Please wait 5 minutes before refreshing your browser to see if your
            Right to Work check has been successful.
          </p>
        </div>
      </div>
      <div className={`mt-auto mb-lg-2 ${style.actions}`}>
        <Link to={findStep("contract-for-services", jobId)}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <Button classes="btn btn-primary btn-block" onClick={navigateForward}>
          Next
        </Button>
      </div>
    </Fragment>
  );
};

export default YotiCheckSuccessful;
